import {Helmet} from "react-helmet";

const Jobber = () => (
    
    <div>
        <div id="8781693e-7df6-4a44-9790-4dd651ae2e33-503431">
            </div>
        <Helmet>
            <link rel="stylesheet" href="https://d3ey4dbjkt2f6s.cloudfront.net/assets/external/work_request_embed.css" media="screen" />
            <script src="https://d3ey4dbjkt2f6s.cloudfront.net/assets/static_link/work_request_embed_snippet.js" 
                    clienthub_id="8781693e-7df6-4a44-9790-4dd651ae2e33-503431" 
                    form_url="https://clienthub.getjobber.com/client_hubs/8781693e-7df6-4a44-9790-4dd651ae2e33/public/work_request/embedded_work_request_form?form_id=503431">
            </script>
        </Helmet>
    </div>
)

export default Jobber;